import { render, staticRenderFns } from "./PageRegLink.vue?vue&type=template&id=791b9c49&scoped=true"
import script from "./PageRegLink.vue?vue&type=script&lang=js"
export * from "./PageRegLink.vue?vue&type=script&lang=js"
import style0 from "./PageRegLink.vue?vue&type=style&index=0&id=791b9c49&prod&scoped=true&lang=css"
import style1 from "./PageRegLink.vue?vue&type=style&index=1&id=791b9c49&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791b9c49",
  null
  
)

export default component.exports